import { CommitAction } from "@/enum/CommitAction"


export interface AlsBase {
    id:number|null
    libelle:string
    commit:CommitAction
}

export const getDefaultAlsBase = (commit:CommitAction=CommitAction.listAndDic):AlsBase => {
    return {
        id:null,
        libelle:'',
        commit
    }
}